import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { useMediaQuery, useTheme, Box, Tooltip } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useActiveComponent } from '../ActiveComponentContext.js';
import { generatePath } from '../../utils/categoryUtils/index.js';

const CategoryPostCard = ({
  images = [], //array of images
  title,
  summary,
  id,
  postID, //this is the actual post ID
  photoURL,
  username,
  name,
  email,
  date,
  category,
  country,
  onClick,
  location,
  vertical = '260px',
  horizontal = '300px',
}) => {
  const {
    currentUser,
    setShowAlertDialog,
    setIsBookmarkForAlert,
    bookmarks, // Provide the bookmarks state
    toggleBookmark, // Provide the toggleBookmark function
  } = useAuth();
  const { setActivePath } = useActiveComponent();
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md')); // breakpoints for where screen size is decided
  const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));
  const [currentIndex, setCurrentIndex] = useState(0); // Index for the current image
  const [anchorEl, setAnchorEl] = useState(null);
  const [hover, setHover] = useState(false);

  const open = Boolean(anchorEl);
  const isBookmarked = bookmarks[postID] || false;
  const navigate = useNavigate();
  //const country = address.country //may possibly use later?

  const handleCategoryClick = (category) => {
    const path = generatePath(category);
    setActivePath(path); // Update the active path
    navigate(path);
    //console.log('this category was clicked', category);
  };

  const showPostInfo = () => {
    onClick();
    handleClose();
  };
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  //used when is bookmarked is stored in context:
  const handleBookmarkClick = () => {
    if (!currentUser) {
      setShowAlertDialog(true);
      setIsBookmarkForAlert(true);
      return;
    }
    //Info about post sent when saving bookmark to database
    toggleBookmark(postID, {
      creatorsUserId: id || null,
      title,
      summary,
      images,
      photoURL,
      username,
      //name,
      email,
      date,
      category,
      country: country || null,
      //city: city || null,
    });
  };

  const handleNextImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };
  const handlePrevImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  //Handle navigation to user's post page, when it's clicked
  const handleUsernameClick = (path) => {
    navigate(path);
    setActivePath(path);
  };

  // Set height conditionally based on screen size
  const height = isMdUp && isLgUp ? vertical : '200px';
  const cardWidth = isMdUp && isLgUp ? horizontal : '300px';

  return (
    <Card
      sx={{
        p: 1.5,
        maxWidth: 400,
        borderRadius: 4,
        width: cardWidth,
        height: {
          xs: '245px',
          sm: '245px',
          md: '260px',
          lg: '280px',
          xl: '280px',
        },
        maxHeight: {
          xs: '250px',
          sm: '250px',
          md: '260px',
          lg: '290px',
          xl: '290px',
        },
        '&:hover': {
          boxShadow: '0px 4px 20px rgba(0, 0, 50, 0.2)', // Custom hover effect
          transform: 'scale(1.02)', // Optional: adds a slight zoom effect
          transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
          backgroundColor: 'ghostwhite',
          cursor: 'pointer',
        },
      }}
    >
      {images && images.length > 0 ? (
        <Box position='relative'>
          <CardMedia
            component='img'
            image={images[currentIndex]}
            alt='post image'
            sx={{
              mb: 0,
              objectFit: 'cover', // Ensures the image covers the area
              //width: cardWidth,
              height: {
                xs: '160px',
                sm: '160px',
                md: '160px',
                lg: '200px',
                xl: '200px',
              },
              borderRadius: 4,
            }}
            onClick={onClick}
          />

          <Box
            sx={{
              position: 'absolute',
              bottom: 0,
              //right: 0,
              p: 0.5,
              width: '95%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography
              variant='body'
              color='black'
              sx={{
                backgroundColor: 'white',
                pl: 1,
                pr: 1,
                pt: 0.3,
                pb: 0.3,
                fontSize: { xs: 9, sm: 9, md: 9, lg: 10, xl: 10 },
                borderRadius: 3,
                ml: 1,
                cursor: 'pointer',
                // fontFamily: 'Roboto',
                fontFamily: 'Montserrat',
                //mb: 0.5,
              }}
              //onClick={() => handleCategoryClick(category)} // Handle category click, but not needed inside categories
            >
              {category}
            </Typography>
            <IconButton disableRipple onClick={handleMenuClick}>
              <MoreHorizIcon
                sx={{
                  color: 'black',
                  backgroundColor: 'white',
                  p: 0.4,
                  fontSize: 13,
                  borderRadius: '50%',
                  mr: { xs: 0, sm: 0, md: 0.1, lg: 0.2, xl: 0.2 },
                }}
              />
            </IconButton>
            <Menu
              sx={{ borderRadius: 10 }}
              id='basic-menu'
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
              }}
            >
              <MenuItem sx={{ fontSize: 12 }} onClick={showPostInfo}>
                Detailed View
              </MenuItem>
            </Menu>
          </Box>
          {/* Arrows only show when there is more than one image */}
          {images.length > 1 && (
            <Box>
              <IconButton
                sx={{
                  width: 20,
                  height: 20,
                  position: 'absolute',
                  top: '50%',
                  left: '10px',
                  transform: 'translateY(-50%)',
                  color: '#030202',
                  backgroundColor: 'white',
                  '&:hover': {
                    color: 'white',
                    backgroundColor: 'dimgrey',
                    boxShadow: '0px 2px 3px grey',
                  },
                }}
                onClick={handlePrevImage}
              >
                <ArrowBackIosIcon sx={{ fontSize: 10 }} />
              </IconButton>
              <IconButton
                sx={{
                  width: 20,
                  height: 20,
                  position: 'absolute',
                  top: '50%',
                  right: '10px',
                  transform: 'translateY(-50%)',
                  color: '#030202',
                  backgroundColor: 'white',
                  '&:hover': {
                    color: 'white',
                    backgroundColor: 'dimgrey',
                    boxShadow: '0px 2px 3px grey',
                  },
                }}
                onClick={handleNextImage}
              >
                <ArrowForwardIosIcon sx={{ fontSize: 10 }} />
              </IconButton>
            </Box>
          )}
        </Box>
      ) : (
        <Box position='relative'>
          <Typography
            variant='body2'
            color='text.secondary'
            sx={{
              display: 'flex',
              textAlign: 'flex-start',
              height: {
                xs: '120px',
                sm: '120px',
                md: '130px',
                lg: '165px',
                xl: '165px',
              },
              overflowY: 'auto',
              borderRadius: 4,
              fontFamily: 'Montserrat',
              backgroundColor: 'black',
              color: 'white',
              m: 0,
              ml: 0,
              mr: 0,
              mt: { xs: 0.5, sm: 0.5, md: 0.5, lg: 0, xl: 0 },
              mb: 1,
              p: 2,
              fontSize: { xs: 10, sm: 10, md: 12, lg: 12, xl: 12 },
              whiteSpace: 'pre-line',
              '&:hover': {
                boxShadow: '0px 1px 2px inset grey',
                cursor: 'grab',
              },
              '&::-webkit-scrollbar': {
                width: '8px',
                backgroundColor: 'transparent',
              },
              '&:hover::-webkit-scrollbar': {
                backgroundColor: '#e0e0e0',
              },
              '&:hover::-webkit-scrollbar-thumb': {
                backgroundColor: '#888',
                borderRadius: '10px',
              },
              '&::-webkit-scrollbar-thumb:hover': {
                backgroundColor: '#555',
              },
            }}
          >
            {summary}
          </Typography>
          <Box
            sx={{
              position: 'absolute',
              bottom: 0,
              p: 0.5,
              width: '95%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography
              variant='body'
              color='black'
              sx={{
                backgroundColor: 'white',
                pl: 1,
                pr: 1,
                pt: 0.3,
                pb: 0.3,
                ml: 1,
                fontSize: { xs: 9, sm: 9, md: 9, lg: 10, xl: 10 },
                borderRadius: 3,
                cursor: 'pointer',
                fontFamily: 'Montserrat',
              }}
              //onClick={() => handleCategoryClick(category)} // Handle category click
            >
              {category}
            </Typography>
            <IconButton disableRipple onClick={handleMenuClick}>
              <MoreHorizIcon
                sx={{
                  color: 'black',
                  backgroundColor: 'white',
                  p: 0.4,
                  fontSize: 13,
                  borderRadius: '50%',
                  mr: { xs: 0, sm: 0, md: 0.1, lg: 0.2, xl: 0.2 },
                }}
              />
            </IconButton>
            <Menu
              sx={{ borderRadius: 10 }}
              id='basic-menu'
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
              }}
            >
              <MenuItem sx={{ fontSize: 12 }} onClick={showPostInfo}>
                Detailed View
              </MenuItem>
            </Menu>
          </Box>
        </Box>
      )}

      {/* Below image, all other content */}
      <CardContent sx={{ p: 0 }}>
        <Box gap={1} sx={{ display: 'flex', mt: 0.5 }}>
          <Typography
            gutterBottom
            variant='h6'
            component='div'
            sx={{
              display: 'flex',
              textAlign: 'flex-start',
              height: '40px',
              maxHeight: '40px',
              width: '100%',
              overflowY: 'auto',
              fontSize: { xs: 12, sm: 12, md: 12, lg: 12, xl: 12 },
              mb: 0,
              mt: 0,
              m: 0,
              p: 0.4,
              '&:hover': { borderRadius: 2, cursor: 'pointer' },
              '&::-webkit-scrollbar': {
                width: '8px', // Width of the scrollbar
                backgroundColor: 'transparent', // Hide scrollbar background by default
              },
              '&:hover::-webkit-scrollbar': {
                backgroundColor: '#e0e0e0', // Show the scrollbar on hover
              },
              '&:hover::-webkit-scrollbar-thumb': {
                backgroundColor: '#888', // Show the scrollbar on hover
                borderRadius: '10px', // Round the corners of the scrollbar thumb
              },
              '&::-webkit-scrollbar-thumb:hover': {
                backgroundColor: '#555', // Darker color when hovered over the scrollbar thumb
              },
            }}
          >
            {title}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            p: 0,
          }}
        >
          <Typography
            onClick={() => handleUsernameClick(`/${username}`)}
            variant='body1'
            color='text.secondary'
            sx={{
              mt: 0,
              fontSize: { xs: 10, sm: 10, md: 11, lg: 12, xl: 12 },
              '&:hover': {
                cursor: 'pointer',
                textShadow: '0px 0px 0.5px black',
              },
            }}
          >
            {photoURL && (
              <IconButton
                disableRipple
                //onClick={handleOpenUserMenu}  //will send u to users page with all their posts
                sx={{
                  p: 0,
                }}
              >
                <Avatar
                  alt={name || 'User'}
                  src={photoURL || null}
                  sx={{
                    width: { xs: 19, sm: 19, md: 19, lg: 22, xl: 22 },
                    height: { xs: 19, sm: 19, md: 19, lg: 22, xl: 22 },
                    mr: 0.5,
                    ml: 0.5,
                    mb: 0.2,
                    //border:'2px solid blue',
                    fontSize: { xs: 9, sm: 9, md: 10, lg: 11, xl: 11 },
                    bgcolor: photoURL ? 'crimson' : 'violet',
                    '&:hover': {
                      cursor: 'pointer',
                      boxShadow: '0px 0px 4px black',
                    },
                  }}
                >
                  {!photoURL && (name?.[0] || email?.[0] || 'U')}
                </Avatar>
              </IconButton>
            )}
            {username}
          </Typography>
          <Tooltip title={isBookmarked ? 'Unsave Post' : 'Save Post'}>
            <IconButton disableRipple onClick={() => handleBookmarkClick()}>
              {isBookmarked ? (
                <BookmarkIcon
                  sx={{
                    fontSize: {
                      xs: 20,
                      sm: 20,
                      md: 21,
                      lg: 22,
                      xl: 22,
                    },
                    mt: 0,
                    color: 'crimson',
                  }}
                />
              ) : (
                <BookmarkBorderIcon
                  sx={{
                    fontSize: {
                      xs: 21,
                      sm: 21,
                      md: 21,
                      lg: 22,
                      xl: 22,
                    },
                    mt: 0,
                    color: 'crimson',
                    '&:hover': {
                      transform: 'scale(1.11)', // Optional: adds a slight zoom effect
                      transition:
                        'transform 0.5s ease-in-out, box-shadow 0.3s ease-in-out',
                    },
                  }}
                />
              )}
            </IconButton>
          </Tooltip>
        </Box>
      </CardContent>
    </Card>
  );
};

export default CategoryPostCard;
